module.exports = __webpack_public_path__ + "assets/img/empty.9b4204a4.png";